import { NavLink } from "react-router-dom";
import { TrendingUp } from "lucide-react";
import { NAV_LINKS } from "./navLinks";

/** Desktop navigation. On mobile the bottom bar (BottomNav) takes over instead. */
export function Sidebar() {
  return (
    <aside className="hidden w-64 shrink-0 flex-col border-r border-slate-800 bg-slate-900/40 md:flex">
      <div className="flex h-16 items-center gap-2 border-b border-slate-800 px-6">
        <TrendingUp className="h-5 w-5 text-emerald-400" />
        <span className="text-sm font-semibold tracking-wide text-slate-100">MT5 Dashboard</span>
      </div>
      <nav className="flex-1 space-y-1 px-3 py-4">
        {NAV_LINKS.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors ${
                isActive
                  ? "bg-emerald-500/10 text-emerald-400"
                  : "text-slate-400 hover:bg-slate-800/60 hover:text-slate-100"
              }`
            }
          >
            <Icon className="h-4 w-4" />
            {label}
          </NavLink>
        ))}
      </nav>
      <div className="border-t border-slate-800 px-6 py-4 text-xs text-slate-500">
        Monitoring only &middot; no remote control
      </div>
    </aside>
  );
}
